/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ project: NonNullable<unknown>, question: NonNullable<unknown> }} Uno_Confirm_Start_Project_ChatInputs */



/**
* | output |
* | --- |
* | "Open a new chat in “{project}” and ask: {question}" |
*
* @param {Uno_Confirm_Start_Project_ChatInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_confirm_start_project_chat = /** @type {((inputs: Uno_Confirm_Start_Project_ChatInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Confirm_Start_Project_ChatInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Neuen Chat in „${i?.project}“ öffnen und fragen: ${i?.question}`)
	return /** @type {LocalizedString} */ (`Open a new chat in “${i?.project}” and ask: ${i?.question}`)
});